'use es6';

export var WEIGHTS = {
  regular: 'regular',
  medium: 'medium',
  bold: 'bold',
  demi: 'demi'
};
export var USES = {
  error: 'error',
  help: 'help',
  success: 'success'
};